import { render, staticRenderFns } from "./order.vue?vue&type=template&id=36c5bbe9&scoped=true&"
import script from "./order.vue?vue&type=script&lang=js&"
export * from "./order.vue?vue&type=script&lang=js&"
import style0 from "./order.vue?vue&type=style&index=0&lang=less&"
import style1 from "./order.vue?vue&type=style&index=1&id=36c5bbe9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c5bbe9",
  null
  
)

export default component.exports